import { FC } from 'react'
import styled from 'styled-components'
import { Image, TextLegacy } from '@/components/common'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'
import { isOrderStatusCancel, isOrderStatusExchange, isOrderStatusReturn } from '@/constants/legacy/constData'
import { OrderStatusTypeEnum } from '@/constants/order-status-type.enum'
import { IModelOrderItem } from '@/containers/models/modelOrderItem'
import { IModelReturnInfoImage } from '@/containers/models/modelReturnInfoImage'

type OrderDetailSectionCancelReasonInfoProps = {
  status: OrderStatusTypeEnum
  orderItem: IModelOrderItem
}

const OrderDetailSectionCancelReasonInfo: FC<OrderDetailSectionCancelReasonInfoProps> = ({ status, orderItem }) => {
  const getStatusText = () => {
    if (isOrderStatusCancel(status)) {
      return '취소'
    }
    if (isOrderStatusReturn(status)) {
      return '반품'
    }
    if (isOrderStatusExchange(status)) {
      return '교환'
    }
  }

  const {
    getCancelRequestedAtText,
    getCancelFinishedAtText,
    getCancelReasonText,
    getCancelGuideMessageText,
    getCancelImages,
  } = orderItem

  return (
    <StyledContainer>
      <TitleRow>
        <TextLegacy size={{ xs: 16, md: 18 }} weight="bold">
          상세정보
        </TextLegacy>
      </TitleRow>
      <RenderRow title={`${getStatusText()} 접수일`} value={getCancelRequestedAtText()} />
      <RenderRow title={`${getStatusText()} 완료일`} value={getCancelFinishedAtText()} />
      <RenderRow title={`${getStatusText()}사유`} value={getCancelReasonText()} />
      {getCancelGuideMessageText() && <RenderRow title="관리자 안내" value={getCancelGuideMessageText()!} />}
      {getCancelImages() && <RenderImages images={getCancelImages()!} />}
    </StyledContainer>
  )
}

const RenderRow = ({ title, value }: { title: string; value: string }) => (
  <ItemRow align="flex-start">
    <NewCol
      style={{
        width: '10rem',
      }}
    >
      <TextLegacy color="gray400">{title}</TextLegacy>
    </NewCol>
    <NewCol>
      <TextLegacy>{value}</TextLegacy>
    </NewCol>
  </ItemRow>
)

/**
 * TODO: 반품 페이지 확인 하지 못해서 Row, Col antd 확인 필요
 * @param param0
 * @returns
 */
const RenderImages = ({ images }: { images: IModelReturnInfoImage[] }) => {
  return (
    <>
      <ItemRow align="flex-start">
        <NewCol>
          <TextLegacy color="gray400">첨부한 사진</TextLegacy>
        </NewCol>
      </ItemRow>
      <NewRow>
        {images.map((image, index) => (
          <NewCol
            key={index}
            style={{
              width: '25%',
            }}
          >
            <Image src={image.thumbnail} layout="responsive" width={200} height={200} alt="image" objectFit="cover" />
          </NewCol>
        ))}
      </NewRow>
    </>
  )
}

const TitleRow = styled.div`
  margin-bottom: 3rem;
`

const ItemRow = styled(NewRow)`
  padding: 0.5rem 0;
`

const StyledContainer = styled.div`
  padding: 2rem;
  background-color: ${(props) => props.theme.color.grayWhite};
`

export default OrderDetailSectionCancelReasonInfo
